import { render, staticRenderFns } from "./assignedVehicle.vue?vue&type=template&id=26342f45&scoped=true&"
import script from "./assignedVehicle.vue?vue&type=script&lang=js&"
export * from "./assignedVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26342f45",
  null
  
)

export default component.exports